import axios from 'axios';

import StoryblokClient from "storyblok-js-client";

const token = process.env.VUE_APP_STORYBLOK_API_KEY;

let storyapi = new StoryblokClient({
  accessToken: token
});

class RecipesService {
  constructor(http, endpoint) {
    this.http = http;
    this.endpoint = endpoint;
  }
  async getShippingRuns() {
    return this.http.get(`${this.endpoint}/api/shipping_runs/available_for_order.json`)
      .then(r => r.data);
  }
  async getRecipesForShippingRun(
    id,
    query = null,
    meal_plan = null,
    portion_count = null
  ) {
    return this.http.get(`${this.endpoint}/api/shipping_runs/${id}/recipes.json?meal_plan=${meal_plan}&${query}`)
      .then(r => r.data);
  }
  async getMealPlans() {
    return storyapi.get('cdn/datasource_entries', {
      'datasource': 'meal-plans',
      'dimension': 'description'
    }).then(r => r.data.datasource_entries);
  }
  async getFoodGroups() {
    return storyapi.get('cdn/datasource_entries', {
      'datasource': 'food-groups',
      'dimension': 'description'
    }).then(r => r.data.datasource_entries);
  }
}

export const recipesService = new RecipesService(axios, `https://www.mindfulchef.com`);